module.exports = "/_next/static/images/Hero@2x-016c0278401b2980543d21642579986b.png";